import { Button } from '@chakra-ui/react'

export function UsageButton({ idx, link, text, isKangu, onClick }) {
  return (
    <Button
      as="a"
      fontSize="12px"
      href={link}
      target="_blank"
      bg={isKangu ? '#378BBF' : idx % 2 === 0 ? '#FFF' : '#378BBF'}
      color={isKangu ? '#fff' : idx % 2 === 0 ? '#378BBF' : '#FFF'}
      _hover={{
        bg: isKangu ? '#99ca35' : idx % 2 === 0 ? '#d8d8d8' : '#64a3ca',
        color: idx % 2 === 0 ? '#64a3ca' : '#FFF',
      }}
      transform="scale(0.8)"
      minWidth="4rem"
      cursor="pointer"
      onClick={onClick}
    >
      {text}
    </Button>
  )
}
